import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "GET";
export const operationId = "workwearExpressCustomisationPlatformFrontendExistingCustomisationsRepositoryV1GetExistingCustomisationsWithCartForGuestGet";
export const path = "/V1/customisations/{cartId}/saved";
export interface PathParams {
    cartId: string;
}
export type Response = Response200 | ResponseDefault;
export type Response200 = Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface[];
export type RespKeys = (keyof Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface)[];
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "getJSON">;
export function execute<T extends RespKeys | undefined>(pathParams: PathParams, effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface, T[number]>[]> : Observable<Response200> {
    return effects.getJSON(effects.apiUrl(operationId)(path, pathParams, fields), effects.restHeaders({})) as any;
}
